module.exports = __webpack_public_path__ + "eea947b63241ea85c8f75794bfefe373.svg";